import { Errors } from '@equifinance/shared';

export type BrokerDetails = {
  id: string,
  firstName: string,
  surname: string,
  telephoneNumber: string;
  emailAddress: string,
  isAdmin: boolean,
}

export enum BrokerUserStatus {
  PENDING = 'Pending',
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  OPEN = 'Open',
  LOCKEDOUT = 'Locked out',
}

export type BrokerUser = BrokerDetails & { companyId: string, status: keyof typeof BrokerUserStatus };

export type AddBrokerUserPayload = Omit<BrokerUser, 'status'>;
export type UpdateBrokerUserPayload = Omit<BrokerUser, 'status'>;

export type CompanyUsers = {
  id: string,
  users: BrokerUser[]
  errors: Errors
}

export const defaultCompanyUser: CompanyUsers = {
  id: '',
  users: [],
  errors: {},
};
